import { render, staticRenderFns } from "./TicketFormatSelector.vue?vue&type=template&id=006925f2&scoped=true"
import script from "./TicketFormatSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketFormatSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TicketFormatSelector.vue?vue&type=style&index=0&id=006925f2&prod&lang=scss"
import style1 from "./TicketFormatSelector.vue?vue&type=style&index=1&id=006925f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006925f2",
  null
  
)

export default component.exports